import Constants from '@/Constants';
import { DialogFlowMessage } from '@/models/Chat';
import React from 'react';
import ChatBotLearningMapButton from '../ChatBotLearningMapButton';
import ChatCategoriesMessage from '../ChatCategoriesMessage';
import ChatContentMessage from '../ChatContentMessage';

interface Props {
    message: DialogFlowMessage;
}

const ChatActionMessage: React.FC<Props> = (props: Props) => {
    const { message } = props;
    const content = message.payload.richContent[0][0];

    switch (content.path) {
        case Constants.chatBotActionPaths.LIST_CATEGORIES:
            return <ChatCategoriesMessage />;
        case Constants.chatBotActionPaths.RECOMENDATION:
            return <ChatContentMessage data={content} />;
        case Constants.chatBotActionPaths.LEARNING_MAP:
        default:
            return <ChatBotLearningMapButton />;
    }
};

export default ChatActionMessage;
